(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PurchaseSubscriptionController', PurchaseSubscriptionController);

    PurchaseSubscriptionController.$inject = ['$window', '$scope', '$state', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom','LegalActualInfoService'];

    function PurchaseSubscriptionController($window, $scope, $state, $rootScope, $stateParams, entity, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, LegalActualInfoService) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.subscriptionPackages = [];
        vm.subscriptionPackages.push(vm.subscriptionPackage);
        vm.companySubscriptionStatus = {};
        vm.isSaving = false;
        vm.issueBill = false;
        vm.billingName = "";
        vm.billingNationalCode = "";
        vm.issueBillCheckChange = issueBillCheckChange;

        if (vm.subscriptionPackage != null && vm.subscriptionPackage != undefined) {
            vm.companySubscriptionStatus.subscriptionPackage = vm.subscriptionPackage;
        }


        vm.companySubscriptionStatus.couponCodeToValidate = null;


        computeFinalPrice();


        vm.insertCompanySubscription = insertCompanySubscription;
        vm.checkCouponCode = checkCouponCode;
        vm.isSMSPAckage = false;

        if (vm.subscriptionPackage.packageType == 'SMS')
            vm.isSMSPAckage = true;

        function computeFinalPrice() {
            CompanySubscriptionStatusCustom.computeSubscriptionFinalPrice().save(vm.companySubscriptionStatus, function (result) {

                vm.companySubscriptionStatus = result;
            });

        }

        function checkCouponCode() {
            if (!vm.companySubscriptionStatus.couponCodeToValidate)
                return;

            CompanySubscriptionStatusCustom.evaluateSupplierCoupon().save(vm.companySubscriptionStatus, onEvaluateSuccess, onEvaluateError)

        }

        function onEvaluateSuccess(result) {
            if (result.resultStatus == 'DONE') {
                vm.couponResult = result;
                computeFinalPrice();
            }
        }

        function onEvaluateError() {
            vm.couponResult = null;
            computeFinalPrice();
        }


        function insertCompanySubscription() {
            vm.isSaving = true;
            if(vm.issueBill) {
                 LegalActualInfoService.fetchInfo().query(function(result){
                    if(result.id && result.nationalCode) {
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo = {};
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.fisrtName = result.name;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.lastName = result.name;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.nationalCode = result.nationalCode;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.address = result.address;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.zipCode = result.zipCode;
                        CompanySubscriptionStatusCustom.insertCompanySubscriptionStatus().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
                    }
                    else {
                        $state.go('supplierPanel-v2.legal_actualInformation');
                    }
                })
            }else {
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo = {};
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.fisrtName = vm.billingName;
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.lastName = vm.billingName;
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.nationalCode = vm.billingNationalCode;
                CompanySubscriptionStatusCustom.insertCompanySubscriptionStatus().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            }
           
            // if (vm.issueBill && (!vm.billingName || !vm.billingNationalCode)) {
            //     vm.isSaving = false;
            //     return;
            // }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            if (result && result.payUrl) {
                addGTagData();
                $window.location.href = result.payUrl;
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function issueBillCheckChange() {
            if (!vm.issueBill) {
                // vm.companySubscriptionStatus.companyInvoiceInfo = {};
                return;
            }
            if (!vm.companySubscriptionStatus.companyInvoiceInfo) {
                vm.companySubscriptionStatus.companyInvoiceInfo = {};
                vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType = 'PERSONAL';
            } else {
                if (!vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType)
                    vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType = 'PERSONAL';
            }

        }

        function addGTagData() {

            if (!vm.subscriptionPackage || !vm.subscriptionPackage.subscriptionType) {
                return;
            }

            try {
                //user Start Purchase
                gtag('event', 'purchase_start', {
                    "items": [
                        {
                            "id": "PL103",
                            "name": vm.subscriptionPackage.title + "--" + vm.subscriptionPackage.durationDays + " Days",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": vm.subscriptionPackage.subscriptionType,
                            "price": vm.subscriptionPackage.chargeFee
                        }
                    ]
                });
            } catch (err) {
                console.log(err);
            }

        }

    }
})();
